import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trophy, Target } from "lucide-react";

export default function Leaderboard() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/leaderboard")
      .then((r) => setList(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-6 sm:px-8 md:px-12 py-16" data-testid="leaderboard-page">
      <div className="label-mono mb-3">Top Detectors</div>
      <h1 className="font-display font-black text-4xl md:text-6xl uppercase tracking-tighter mb-10">
        Leaderboard
      </h1>

      <div className="card overflow-hidden">
        <div className="grid grid-cols-12 px-6 py-4 label-mono border-b" style={{ borderColor: "var(--border)" }}>
          <div className="col-span-1">#</div>
          <div className="col-span-5">Player</div>
          <div className="col-span-2 text-right">Votes</div>
          <div className="col-span-2 text-right">Accuracy</div>
          <div className="col-span-2 text-right">Points</div>
        </div>
        {loading ? (
          <div className="p-8 label-mono">Loading…</div>
        ) : list.length === 0 ? (
          <div className="p-12 text-center">
            <Trophy size={32} className="mx-auto mb-4" style={{ color: "var(--text-faint)" }} />
            <div className="label-mono mb-2">No one on the board yet</div>
            <div style={{ color: "var(--text-dim)" }}>Be the first to vote and claim #1.</div>
          </div>
        ) : (
          list.map((u, i) => (
            <div key={u.id} className="grid grid-cols-12 px-6 py-4 items-center border-b" style={{ borderColor: "var(--border)" }} data-testid={`leaderboard-row-${i}`}>
              <div className="col-span-1 font-display font-bold text-xl">
                {i === 0 ? <Trophy size={18} style={{ color: "#fbbf24" }} /> : `${i + 1}`}
              </div>
              <div className="col-span-5 font-medium">{u.name}</div>
              <div className="col-span-2 text-right label-mono">{u.total_votes}</div>
              <div className="col-span-2 text-right label-mono" style={{ color: u.accuracy >= 70 ? "var(--success)" : u.accuracy >= 50 ? "var(--text)" : "var(--text-dim)" }}>
                <Target size={11} className="inline mr-1" />{u.accuracy}%
              </div>
              <div className="col-span-2 text-right font-display font-bold">{u.points}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
